import { SET_NEW_SEGMENT_CONFIG } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (data) => panelLayoutV2Actions[SET_NEW_SEGMENT_CONFIG](data);
